export default function FieldInput({ formik, name, label, ...props }) {
  return (
    <div className="input-block">
      {label && <label>{label}</label>}
      <input
        id={name}
        name={name}
        onChange={formik.handleChange}
        value={formik.values[name]}
        type="text"
        className="form-control cabinet__input"
        {...props}
      />
      {formik.errors[name] && formik.touched[name] ? (
        <label id="email-error" htmlFor="email" className="error-field">
          {formik.errors[name]}
        </label>
      ) : null}
    </div>
  )
}
